import {  put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";


export const actionTypes = {
    SelectStatusCkeckQuestin: "SelectStatusCkeckQuestin [Action]",
    SelectStatusCkeckQuestinLoading: "SelectStatusCkeckQuestinLoading [Action]",
    SelectStatusCkeckQuestinAsync: "SelectStatusCkeckQuestinAsync [Action]",
};
const inistiaState = {
    data: {},
    loading: false
};

export const reducerSelecStatusCkeckQuestint = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.SelectStatusCkeckQuestin:
            return {
                ...state,
                data: payload,
            };
        case actionTypes.SelectStatusCkeckQuestinLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.SelectStatusCkeckQuestinLoading, payload: true })


    let config = {
        url: "select_request",
        "token": "3cf61fab-b50a-410f-9d59-3357ee4706fe",
    };

    let data = {
        table: "questionnaire",
        method_type: "member_exam_state",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.SelectStatusCkeckQuestin, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.SelectStatusCkeckQuestinLoading, payload: false })

    }
}

export function* selectStatusCkeckQuestint() {
    yield takeLatest(actionTypes.SelectStatusCkeckQuestinAsync, handleWorker);
}
